import Image from "next/image"

export function LoginBranding() {
  return (
    <div className="relative hidden md:flex w-1/2 min-h-dvh flex-col items-center justify-center px-8 overflow-hidden bg-linear-to-br from-navy-700 via-navy-800 to-navy-900">
      {/* Subtle radial gold glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(191,154,76,0.12),_transparent_60%)]"
      />
      {/* Gold accent hairlines top and bottom */}
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-0 h-px bg-linear-to-r from-transparent via-gold-500/60 to-transparent"
      />
      <div
        aria-hidden="true"
        className="absolute inset-x-0 bottom-0 h-px bg-linear-to-r from-transparent via-gold-500/60 to-transparent"
      />

      <div className="relative flex flex-col items-center gap-10 animate-in fade-in duration-700">
        {/* Cherish logo rendered in white */}
        <Image
          src="/images/cherish-logo.png"
          alt="Cherish"
          width={300}
          height={180}
          className="brightness-0 invert drop-shadow-[0_4px_20px_rgba(191,154,76,0.15)]"
          style={{ width: "auto", height: "auto" }}
          priority
        />

        {/* Gold divider with dot */}
        <div className="flex items-center gap-3" aria-hidden="true">
          <span className="h-px w-16 bg-linear-to-r from-transparent to-gold-400/60" />
          <span className="h-1.5 w-1.5 rounded-full bg-gold-400 shadow-[0_0_12px_theme(colors.gold.400)]" />
          <span className="h-px w-16 bg-linear-to-l from-transparent to-gold-400/60" />
        </div>

        <div className="text-center flex flex-col items-center gap-2">
          <p className="text-white text-xl font-semibold leading-relaxed tracking-tight">
            Cherish at Central Park
          </p>
          <p className="text-gold-300 text-xs uppercase tracking-[0.24em] font-semibold">
            Hospitality Services
          </p>
        </div>
      </div>

      {/* Elegant bottom tagline */}
      <div className="absolute bottom-8 inset-x-0 text-center">
        <p className="font-heading italic text-xs text-gold-400/80 tracking-wide">
          Your well-being is our greatest privilege
        </p>
      </div>
    </div>
  )
}
